/**
 * API service for the AI Chat study assistant.
 *
 * All endpoints hit the LMS backend at /euka-api/v1/chat/*
 * Authentication is handled automatically by the httpClient.
 */

import type {
  ChatClearResponse,
  ChatHistoryResponse,
  ChatMessageRequest,
  ChatMessageResponse
} from "@/ts/interfaces/chat/chatInterface";
import { get, post } from "./httpClient";

/**
 * Send a message to the AI study assistant and receive a response.
 */
export const sendChatMessage = async (
  payload: ChatMessageRequest
): Promise<ChatMessageResponse> => {
  return await post<ChatMessageResponse>("/chat/messages", payload);
};

/**
 * Fetch the chat history for a specific lesson.
 */
export const getChatHistory = async (
  lessonKey: string
): Promise<ChatHistoryResponse> => {
  return await get<ChatHistoryResponse>(
    `/chat/history?lesson_id=${encodeURIComponent(lessonKey)}`
  );
};

/**
 * Clear the chat history for a specific lesson.
 */
export const clearChatHistory = async (
  lessonKey: string
): Promise<ChatClearResponse> => {
  return await post<ChatClearResponse>("/chat/clear", {
    lesson_id: lessonKey
  });
};

export const chatApi = { sendChatMessage, getChatHistory, clearChatHistory };
